/**
 * The contact API returns `openingHour` as two values separated by "|":
 * the first is English, the second is Arabic (e.g. "Mon-Sun 6 AM-10 PM|...").
 *
 * Returns the part matching the locale (Arabic for "ar", English otherwise),
 * or `undefined` when no usable value is present so callers can fall back.
 */
export function getLocalizedOpeningHour(
  openingHour: string | undefined,
  locale: string
): string | undefined {
  if (!openingHour) return undefined;

  const [english = "", arabic = ""] = openingHour.split("|");
  const value = locale.startsWith("ar") ? arabic || english : english;
  const trimmed = value.trim();

  return trimmed.length > 0 ? trimmed : undefined;
}
